// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Axios from 'axios';
import Moment from 'moment';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueGoodTable from 'vue-good-table';
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import FileSaver from 'file-saver';

// importar jQuery, el canvas per als grafs i el daterangepicker
window.$ = require('jquery');
window.jQuery = require('jquery');
window.zingchart = require('../static/js/jquery.canvasjs');
require('../static/js/zingchart/zingchart.min');
require('daterangepicker');
import 'daterangepicker/daterangepicker.css';

window.axios = Axios;
window.moment = Moment;
window.swal = swal;
window.FileSaver = FileSaver;

Vue.prototype.$http = Axios;
Vue.use(VueGoodTable);
Vue.use(VueGoogleMaps, {
  installComponents: true,
  load: {
    key: 'AIzaSyDHP1Nt9prUCS9RbFY_BUQDnXn8I9j4ias',
    // v: '3.26',
    libraries: 'places'
  }
});

window.axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
};

if(window.localStorage.getItem('token') !== null){
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.getItem('token');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js